import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import Alert from '../../../../Alert';
import Insurance from './Insurance';

import LoanService from '../../../../../services/LoanService';

export default function BorrowerInsurances({ loanId, loan }) {
  const { t } = useTranslation();

  const { data: insurances, isFetched } = useQuery({
    queryKey: ['borrowerLoanInsurances', loanId],
    queryFn: () => LoanService.getBorrowerLoanInsurances(loanId),
    enabled: !!loanId,
  });

  const insuranceImpound = loan?.insurance_impound;
  const hasNoInsurances = (!insurances?.length || !insurances) && isFetched;

  return (
    <div>
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
        {t(
          'AddOrEditPage.AddOrEditLoan.Sections.BorrowerInsurances.Active Insurance Policies'
        )}
      </h2>
      {hasNoInsurances && (
        <div className="mb-5">
          <Alert
            message={
              insuranceImpound
                ? t(
                    'AddOrEditPage.AddOrEditLoan.Sections.BorrowerInsurances.NOTE: Your loan is missing an active insurance policy. Please contact us.'
                  )
                : t(
                    'AddOrEditPage.AddOrEditLoan.Sections.BorrowerInsurances.Your loan is not setup for insurance escrow and tracking.'
                  )
            }
          />
        </div>
      )}
      {insurances?.map((insurance) => (
        <Insurance key={insurance.id} insurance={insurance} />
      ))}
    </div>
  );
}
